import { loader } from 'graphql.macro'

export const getSignedUrl = loader('./getSignedUrl.graphql')
